export const name_validation_pl = {
  name: "name",
  label: "name",
  type: "text",
  id: "name",
  placeholder: "Twoje imię",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "wymagane",
    },
    maxLength: {
      value: 30,
      message: "maksymalnie 30 znaków",
    },
  },
};

export const from_hidden_validation_pl = {
  name: "form",
  label: "form",
  type: "hidden",
  id: "form",
  placeholder: "",
  className: "",
  value: "Footer Form",
  validation: {
    required: {
      value: true,
      message: "wymagane",
    },
  },
};

export const to_hidden_validation_pl = {
  name: "to",
  label: "to",
  type: "hidden",
  id: "to",
  placeholder: "",
  className: "",
  value: "web@twid.marketing",
  validation: {
    required: {
      value: true,
      message: "wymagane",
    },
  },
};

export const company_validation_pl = {
  name: "company",
  label: "company",
  type: "text",
  id: "company",
  placeholder: "Firma",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: false,
      message: "wymagane",
    },
    maxLength: {
      value: 30,
      message: "maksymalnie 30 znaków",
    },
  },
};

export const message_validation_pl = {
  name: "message",
  label: "message",
  type: "textarea",
  multiline: true,
  id: "message",
  placeholder: "Wiadomość",
  className: "",
  validation: {
    required: {
      value: true,
      message: "wymagane",
    },
    maxLength: {
      value: 200,
      message: "maksymalnie 200 znaków",
    },
  },
};

export const password_validation_pl = {
  name: "password",
  label: "password",
  type: "password",
  id: "password",
  placeholder: "type password ...",
  validation: {
    required: {
      value: true,
      message: "wymagane",
    },
    minLength: {
      value: 6,
      message: "min 6 characters",
    },
  },
};

export const num_validation_pl = {
  name: "num",
  label: "number",
  type: "number",
  id: "num",
  placeholder: "write a random number",
  validation: {
    required: {
      value: true,
      message: "wymagane",
    },
  },
};

export const email_validation_pl = {
  name: "email",
  label: "email address",
  type: "email",
  id: "email",
  placeholder: "E-mail",
  multiline: false,
  className: "",
  validation: {
    required: {
      value: true,
      message: "wymagane",
    },
    pattern: {
      value:
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
      message: "nieprawidłowy",
    },
  },
};
